@if (showOverlay()) {
  <button aria-label="Flowchart Placeholder Overlay" class="tt-flowchart_placeholder" (click)="onOverlayClick($event)">
    <span class="tt-flowchart_placeholder_content">
      <mat-icon [icon]="'move'" [iconSize]="18" />
      {{ 'GuidelineEditor.Widgets.Flowchart.Placeholder' | transloco }}
    </span>
  </button>
}
<tt-flowchart-toolbar [fullScreenMode]="fullScreen" [isEditable]="allowEvents" (toolbarItemClicked)="onToolbarEvent($event)" />
<div class="main-container">
  <div
    #paper
    class="paper-container"
    id="paper-container"
    (click)="handlePaperClick($event)"
    (dragover)="handleDragOver($event)"
    (drop)="handleDrop($event)"></div>
</div>
